import { NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { singleOrderDetails } from '../../../../@store/orders/orders.model';
import { OrdinalPipe } from '../ordinal.pipe';

@Component({
  selector: 'ciwc-order-job-follow-up',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    NgForOf,
    OrdinalPipe,
    NgIf,
  ],
  standalone: true,
  templateUrl: './order-job-follow-up.component.html',
  styleUrl: './order-job-follow-up.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderJobFollowUpComponent {
  @Input() followUps!: FormArray;
  @Input() orderDetails!: singleOrderDetails | null;
  @Output() addFollowUp = new EventEmitter<void>();
  @Output() removeFollowUp = new EventEmitter<number>();
  @Input() viewDisable!: boolean;

  trackByIndex(index: number) {
    return index;
  }

  asFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  getOrdinal(n: number): string {
    if (n === 1) return '1st';
    if (n === 2) return '2nd';
    if (n === 3) return '3rd';
    return `${n}th`;
  }
}
